module.exports = __webpack_public_path__ + "static/img/niksen2.f1d18e95.jpg";